/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { GridContext as o } from "../../GridClientWrapper.mjs";
import { DragAndDrop as n } from "@progress/kendo-react-common";
import { cloneReactElement as l } from "../../utils/index.mjs";
const d = (t) => {
  const r = e.useContext(o);
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.rowReorderable ? /* @__PURE__ */ e.createElement(n, null, t.children) : l(t.children, {
    ref: r.tableBodyElementRef
  }));
};
export {
  d as GridTableBody
};
